export const conselhoAtletas = {
    descricao: "CONSELHO DE ATLETAS",
    pessoas: []
}
